import { forwardRef } from 'react';
import Tabs from './tabs.factory.js';
import Tab from '../tab/tab.js';
var _TabsPropsManager = function TabsPropsManager(ins, props) {
  var dir = props.dir,
    isVertical = props.isVertical;
  var result = {
    className: ins.getSetting('tablistClass') + ' ' + ins.getSetting(dir + "Class")
  };
  if (isVertical) {
    result.className += ' ' + ins.getSetting('verticalClass');
  }
  if (ins.getOption('accessibility')) {
    result.role = 'tablist';
  }
  return result;
};
export { _TabsPropsManager as TabsPropsManager };
export default /*#__PURE__*/forwardRef(Tabs.bind(undefined, function (ins) {
  return {
    Tab: Tab,
    TabsPropsManager: function TabsPropsManager(props) {
      return _TabsPropsManager(ins, props);
    }
  };
}));